import * as React from 'react';
type Props = {
  className?: string;
};
export function HomeFilled({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-home-filled"
      className={className}
    >
      <path
        d="M21.6674 10.3176L12.6674 2.25764C12.4836 2.0918 12.2449 2 11.9974 2C11.7499 2 11.5111 2.0918 11.3274 2.25764L2.3274 10.3176C2.1782 10.4533 2.07347 10.6308 2.02697 10.827C1.98046 11.0232 1.99434 11.2288 2.06679 11.417C2.13924 11.6051 2.26688 11.767 2.43295 11.8813C2.59902 11.9957 2.79578 12.0571 2.9974 12.0576H4.9974V19.0576C4.9974 19.5881 5.20811 20.0968 5.58318 20.4719C5.95826 20.8469 6.46696 21.0576 6.9974 21.0576H9.6274C9.89261 21.0576 10.147 20.9523 10.3345 20.7647C10.522 20.5772 10.6274 20.3229 10.6274 20.0576V15.3376H13.5574V20.0076C13.5574 20.2729 13.6628 20.5272 13.8503 20.7147C14.0378 20.9023 14.2922 21.0076 14.5574 21.0076H16.9974C17.5278 21.0076 18.0365 20.7969 18.4116 20.4219C18.7867 20.0468 18.9974 19.5381 18.9974 19.0076V12.0076H20.9974C21.199 12.0071 21.3958 11.9457 21.5618 11.8313C21.7279 11.717 21.8556 11.5551 21.928 11.367C22.0005 11.1788 22.0143 10.9732 21.9678 10.777C21.9213 10.5808 21.8166 10.4033 21.6674 10.2676V10.3176Z"
        fill="currentColor"
      />
    </svg>
  );
}
